import { render, staticRenderFns } from "./testInterpretation.vue?vue&type=template&id=e8fb448c&scoped=true&"
import script from "./testInterpretation.vue?vue&type=script&lang=js&"
export * from "./testInterpretation.vue?vue&type=script&lang=js&"
import style0 from "./testInterpretation.vue?vue&type=style&index=0&id=e8fb448c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fb448c",
  null
  
)

export default component.exports